<section id="standard-rates-per-plan-based-issuing-office">
    <div class="mtn-container">
        <div class="mtn-title">
            <p>{{this.moduleName}}</p>
        </div>
        <div class="form-content">
            <form [formGroup]="paramForm" class="form">
                <div class="form-container-grid top-form form-container-change-grid">
                    <div class="field required">
                        <label>User Type</label>
                    </div>
                    <div class="lov-search">
                        <input readonly formControlName="userTypeField">
                        <button matSuffix class="btn-search btn" type="button" (click)="openUserTypeDialog()"><mat-icon>search</mat-icon></button>
                    </div>
                    <div class="field required">
                        <label>Issue Source</label>
                    </div>
                    <div class="lov-search">
                        <input readonly formControlName="issueField">
                        <button matSuffix class="btn-search btn" type="button" (click)="openIssDialog()"><mat-icon>search</mat-icon></button>
                    </div>
                    <div class="field required">
                        <label>Line</label>
                    </div>
                    <div class="lov-search">
                        <input readonly formControlName="lineField">
                        <button matSuffix class="btn-search btn" type="button" (click)="openLineDialog()"><mat-icon>search</mat-icon></button>
                    </div>
                    <div class="field required">
                        <label>Subline</label>
                    </div>
                    <div class="lov-search">
                        <input readonly formControlName="sublineField">
                        <button matSuffix class="btn-search btn" type="button" (click)="openSublineDialog()" [disabled]="sublineDisabled"><mat-icon>search</mat-icon></button>
                    </div>
                    <div class="field">
                        <label></label>
                    </div>
                    <div class="">
                    </div>
                    <div class="field required">
                        <label>Plan</label>
                    </div>
                    <div class="lov-search">
                        <input readonly formControlName="planField">
                        <button matSuffix class="btn-search btn" type="button" (click)="openPlanDialog()" [disabled]="planDisabled"><mat-icon>search</mat-icon></button>
                    </div>
                </div>
            </form>
        </div>
        <div class = 'table-line'>
            <osp-table [tblConfig]="standardRatesPerPlanBasedIOTblConfig" (onRowClick)="onRowClick($event)"></osp-table>
        </div>

        <!-- Loading Animation -->
        <div id="generate-line-form">
            <div class="form-loader"></div>
        </div>

        <!-- Container for Line Fields -->
        <div class="form-content">
            <form [formGroup]="standardRatesPerPlanBasedIOForm" class="form" *ngIf="noLoadingInProcess">
                <div id="standard-rates-per-plan-based-issuing-office-error-message"></div>
                <div class="form-container-grid">
                    <div class="field required">
                        <label>Plan Amount</label>
                    </div>
                    <div class="">
                        <input formControlName="planAmt" type="text" maxlength="17"  (focusout)="amtFormat('planAmt')" [readonly]="isLineSelected">
                    </div>
                    <div class="field required">
                        <label>Active</label>
                    </div>
                    <div class="">
                        <select formControlName="activeTag">
                            <option value="A" selected>Yes</option>
                            <option value="I">No</option>
                        </select>
                    </div>
                    <div class="field required">
                        <label>Commission Rate</label>
                    </div>
                    <div class="">
                        <input formControlName="commissionRate" type="text" maxlength="13" (focusout)="rateFormat('commissionRate')">
                    </div>
                    <div class="field">
                        <label>No. of Days</label>
                    </div>
                    <div class="">
                        <input formControlName="noOfDays" type="text" maxlength="13">
                    </div>
                    <div class="field required">
                        <label>Effective Date</label>
                    </div>
                    <div class="">
                        <input date-input formControlName="effDateFrom" type="text" placeholder="MM/DD/YYYY" [readonly]="isLineSelected" [matDatepicker]="effDateFromPicker" (input)="datePattern($event)" maxlength="10">
                        <mat-datepicker-toggle matSuffix [for]="effDateFromPicker" *ngIf="!isLineSelected"></mat-datepicker-toggle>
                        <mat-datepicker #effDateFromPicker></mat-datepicker>
                    </div>
                    <div class="field">
                        <label>Expiry Date</label>
                    </div>
                    <div class="">
                        <input date-input formControlName="effDateTo" type="text" placeholder="MM/DD/YYYY" [matDatepicker]="effDateToPicker" (input)="datePattern($event)" maxlength="10">
                        <mat-datepicker-toggle matSuffix [for]="effDateToPicker"></mat-datepicker-toggle>
                        <mat-datepicker #effDateToPicker></mat-datepicker>
                    </div>
                    <div class="field">
                        <label>Remarks</label>
                    </div>
                    <div class="span">
                        <input formControlName="remarks" type="text">
                    </div>
                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="userID">
                    </div>

                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="lastUserUpdate">
                    </div>
                </div>
                <div class='btn-row'>
                    <button type="button" id='btn-add' *ngIf="!isLineSelected" title='Register a new line' class="btn btn2" value='ADD' type="submit" [disabled]='addDisabled' (click)="insertLine()">ADD</button>
                    <button type="button" id='btn-update' *ngIf="isLineSelected" title='Update a line' class="btn btn2" value='UPDATE' type="submit" (click)="updateLine()">UPDATE</button>
                    <button type="button" id='btn-delete' title='Remove a line' class="btn btn2" value='DELETE' type="submit" [disabled]='deleteDisabled' (click)="deleteLine()">DELETE</button>
                </div> 

                <div class="mtn-title"></div>

                <div class='btn-row'>
                    <button type="button" id='btn-save' title='Save changes on line details' class="btn btn2" value='SAVE' type="submit" (click)="toSave()" [disabled]='saveDisabled'>SAVE</button>
                </div>
            </form>
        </div>
    </div>
</section>